import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

import { CommandCenterPage } from "../components/commandCenter/CommandCenterPage";
import { recordVisitedOrg, useActiveOrgId, useOrgs } from "../state/orgs";

/**
 * `/$org/command-center` — the organization's command center: adoption and
 * compliance health on one page, under Chat on the rail.
 *
 * The org segment scopes every figure; the page reads it back through
 * `useActiveOrgId` and the server re-checks it against the session (and
 * answers only the organization's admins). The shell shows no side panel
 * here (AppSidebarLayout), so the page has the whole rounded panel.
 */
function CommandCenterRouteView() {
  const activeOrgId = useActiveOrgId();
  const { orgs } = useOrgs();

  // Visiting an org's command center keeps it the active tenant, as usage does.
  useEffect(() => {
    if (activeOrgId && orgs.some((org) => org.id === activeOrgId)) {
      recordVisitedOrg(activeOrgId);
    }
  }, [activeOrgId, orgs]);

  return <CommandCenterPage />;
}

export const Route = createFileRoute("/$org/command-center")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: CommandCenterRouteView,
});
